import React from 'react'
import Hero from '../components/Hero'
import About from '../components/About'
import Contact from '../components/Contatct'
import Services from '../components/Services'
import Gallery from '../components/Gallery'

const Home = () => {
    return (
        <div className='container'>
            <Hero />
            <About />
            <Services />
            <Gallery />
            <Contact />
        </div>
    )
}

export default Home
